var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#0D4248"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9248_2792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.291 46.9168V13.0835L28.7077 13.0835L28.7077 46.9168H55.291Z",
    stroke: "white",
    strokeWidth: 1.70588,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4368 19.8984C45.5941 21.4511 44.416 23.7711 44.416 26.3751C44.416 28.9791 45.5941 31.2991 47.4368 32.8518",
    stroke: "white",
    strokeWidth: 1.70588,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.541 26.3748C38.2112 26.3748 41.9993 22.5867 41.9993 17.9165",
    stroke: "white",
    strokeWidth: 1.70588,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9993 34.8333C41.9993 30.1631 38.2112 26.375 33.541 26.375",
    stroke: "white",
    strokeWidth: 1.70588,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9993 34.8332C46.6708 34.8332 50.4577 31.0462 50.4577 26.3748C50.4577 21.7034 46.6708 17.9165 41.9993 17.9165C37.3279 17.9165 33.541 21.7034 33.541 26.3748C33.541 31.0462 37.3279 34.8332 41.9993 34.8332Z",
    stroke: "white",
    strokeWidth: 1.70588,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.541 42.0835H50.4577",
    stroke: "white",
    strokeWidth: 1.70588,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9248_2792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 36.25,
    fill: "white",
    transform: "translate(27.5 11.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAwards);
export default __webpack_public_path__ + "static/media/ic-awards.db2b2a9c2352d37eb17e99861fe9f958.svg";
export { ForwardRef as ReactComponent };